module.exports = __webpack_public_path__ + "img/nas-download-icon4.3d302495.png";